import React, { useEffect } from 'react';
import { useLazyGetPageQuery } from '../../../redux/actions/Customer/FooterCustomer';
import { LegalPageLayout } from '../../../components/customer/LegalPageLayout';

export const PrivacyPolicyScreen: React.FC = () => {
    const [triggerGetPage, { data: response, isLoading, isError }] = useLazyGetPageQuery();

    useEffect(() => {
        triggerGetPage(2); // WebsitePageType.PrivacyPolicy = 2
    }, [triggerGetPage]);

    return (
        <LegalPageLayout
            title="Privacy Policy"
            subtitle="Learn how we collect, use, and protect your personal information."
            isLoading={isLoading}
            isError={isError}
            contentData={response?.value?.data || null}
        />
    );
};
export default PrivacyPolicyScreen;